import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/dropdownDefence.css";
import { CSSTransition } from "react-transition-group";

export default function DropdownDefence({ dropdown }) {
  const navigate = useNavigate();

  return (
    <CSSTransition
      in={dropdown}
      timeout={500}
      classNames="fade"
      unmountOnExit={true}
    >
      <div className="dropdownProd">
        <div
          className="dropdown-list"
          onClick={() => navigate("/defence/events")}
        >
          <p>Defence & Event</p>
        </div>

        <div
          className="dropdown-list"
          onClick={() => navigate("/defence/products")}
        >
          <p>Defence Products</p>
        </div>
      </div>
    </CSSTransition>
  );
}
